export default __webpack_public_path__ + "static/media/app7-phone.a47b5155.gif";